module.exports = __webpack_public_path__ + "img/krystallium-power-plant.9a405736.jpg";